import { useMutation } from '@tanstack/react-query';
import { useNavigateKeepSearch } from '@hooks/useNavigateKeepSearch';
import { completeEntraIdSetup } from '../../api/portalServices';
import { useSession } from '../../common/authorization/context/Session';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { type ApiError, AppError } from '../../errorHandler/errors';
import { PortalPath } from '../PortalRoutes';
import { useEntraIdInitialSync } from '@imprivata-cloud/core';

const useEntraIdSetupComplete = () => {
  const { emitError } = useErrorContext();
  const { tenantId } = useSession();
  const navigateKeepSearch = useNavigateKeepSearch();
  const { mutate: startInitialSync } = useEntraIdInitialSync({
    onSuccess: () => {
      console.log('Entra ID initial sync completed');
      navigateKeepSearch(PortalPath.SETTINGS);
    },
    onError: (e: Error) => {
      console.log('Entra ID initial sync failed', e);
      const apiError = e as unknown as ApiError;
      emitError(new AppError(apiError));
    },
  });

  return useMutation({
    mutationFn: async (tenantId: string) => {
      await completeEntraIdSetup(tenantId);
    },
    onSuccess: async () => {
      console.log('Entra ID setup completed');
      startInitialSync(tenantId || '');
    },
    onError: (e: Error) => {
      console.log('Entra ID setup failed', e);
      const apiError = e as unknown as ApiError;
      emitError(new AppError(apiError));
      navigateKeepSearch(PortalPath.SETTINGS);
    },
  });
};

export default useEntraIdSetupComplete;
